// Module
var code = " <mat-icon [hidden]=\"!displayPlaceholder\" class=\"placeholder-color s160\" svgIcon=\"gh:landscape\"></mat-icon> <img [hidden]=\"displayPlaceholder\" #image=\"\">";
// Exports
module.exports = code;